import React from "react";

const DrawingTitleSearch = React.memo(
  ({ component, block, consultant, discipline, projectId, onSearch }) => {
    const prevRef = React.useRef(null);
    const debounceRef = React.useRef(null);

    React.useEffect(() => {
      if (!component || !block || !consultant || !discipline || !projectId) return;

      const current = { component, block, consultant, discipline, projectId, PageNumber: 1,
                PageSize: 100,
                SortBy: "createdDate",
                SortOrder: "desc", };

      if (JSON.stringify(prevRef.current) === JSON.stringify(current)) return;

      clearTimeout(debounceRef.current);

      debounceRef.current = setTimeout(() => {
        prevRef.current = current;
        onSearch(current);
      }, 300);

      return () => clearTimeout(debounceRef.current);
    }, [component, block, consultant, discipline, projectId, onSearch]);

    return null;
  }
);

export default DrawingTitleSearch;